export default __webpack_public_path__ + "static/media/Archdeacon's Bracers of the Spilling Blood.c4319eec.jpg";